import { PickpackLonLat, PickpackStoreAddress } from './MerchantModel';
import { Communicator } from '../../tools/Communication';
import { LayoutStoreInstance } from '../../LayoutStore';
import i18n from '@/utils/i18n';

type boundingBoxLonLatResult = {
  boundingBox: number[];
  lonlat: { latitude: number; longitude: number };
};

export const moveMapToStoreLocation = (latitude: number, longitude: number) => {
  moveMapToBoundingBox(
    getBoundingBoxFromInput(latitude.toString(), longitude.toString()),
  );
};

export const getBoundingBox = (
  latitude: number,
  longitude: number,
): number[] => {
  return [
    latitude - 0.001,
    latitude + 0.001,
    longitude - 0.0005,
    longitude + 0.0005,
  ];
};

export const getBoundingBoxFromInput = (
  latitude: string,
  longitude: string,
): boundingBoxLonLatResult => {
  const latParsed = Number(latitude);
  const lonParsed = Number(longitude);
  return {
    boundingBox: getBoundingBox(latParsed, lonParsed),
    lonlat: {
      longitude: lonParsed,
      latitude: latParsed,
    },
  };
};

export const localizeStore = (
  storeAddress: PickpackStoreAddress,
  onLocationFetchSuccess: (lonlat: PickpackLonLat) => void,
) => {
  let streetNo: any = '';
  if (storeAddress.streetno != null) {
    const match = storeAddress.streetno.match(/\d+/); // match one or more digits
    const firstNumber = match ? parseInt(match[0], 10) : NaN; // convert the matched string to a number
    streetNo = !Number.isNaN(firstNumber) ? firstNumber : '';
  }

  const street = storeAddress.streetname + ' ' + streetNo;
  const param = {
    street,
    city: storeAddress.city,
    postalcode: storeAddress.zip,
    format: 'json',
  };

  Communicator.Get('https://nominatim.openstreetmap.org/search', param, {
    doNotUsePosingRoleHeader: true,
  })
    .then((response) => response.json())
    .then((data: { boundingbox: string[] }[]) => {
      if (data.length === 0) {
        alert(
          'could not find anything for this address. Please check the address',
        );
        return;
      }
      var boundingbox = data[0].boundingbox;
      var centerLat =
        parseFloat(boundingbox[0]) +
        (parseFloat(boundingbox[1]) - parseFloat(boundingbox[0])) / 2;
      var centerLon =
        parseFloat(boundingbox[2]) +
        (parseFloat(boundingbox[3]) - parseFloat(boundingbox[2])) / 2;
      //this.setState({ store: { ...this.state.store, latitude: centerLat, longitude: centerLon} })

      //LayoutStoreInstance.setSuccess(i18n.t('Merchants:localizingStoreSuccessful'))
      //moveMapToStoreLocation(this.state.store)
      moveMapToStoreLocation(centerLat, centerLon);
      onLocationFetchSuccess({ longitude: centerLon, latitude: centerLat });
    })
    .catch((err) => {
      LayoutStoreInstance.setError(i18n.t('Merchants:errorLocalizingStore'));
      //moveMapToStoreLocation(this.state.store)
    });
};

export const moveMapToBoundingBox = (input: boundingBoxLonLatResult) => {
  var iframe = document.getElementById('store-map');
  if (!iframe) {
    console.log('map iframe not found');
    return;
  }

  iframe.setAttribute('src', getMapIframeSrcAttribute(input));
};

//https://www.openstreetmap.org/export/embed.html?bbox=79.84933018684386%2C6.90329331805479%2C79.85746264457703%2C6.908917042549519&marker=6.906105188659279%2C79.85339641571045&layers=ND
export const getMapIframeSrcAttribute = (
  input: boundingBoxLonLatResult,
): string => {
  const { boundingBox, lonlat } = input;
  const bboxstring =
    boundingBox[2] +
    '%2C' +
    boundingBox[0] +
    '%2C' +
    boundingBox[3] +
    '%2C' +
    boundingBox[1];
  const markerstring = lonlat.latitude + ',' + lonlat.longitude;
  return (
    'https://www.openstreetmap.org/export/embed.html?marker=' +
    encodeURIComponent(markerstring) +
    '&bbox=' +
    bboxstring +
    '&amp;layer=mapnik'
  );
};
